"use client";

import * as React from "react";
import type { Lang } from "../copy.js";
import { TopBar } from "./TopBar.js";
import { Hero } from "./Hero.js";
import { DetailsStrip } from "./DetailsStrip.js";
import { EveningBlock } from "./EveningBlock.js";
import { VenueBlock } from "./VenueBlock.js";
import { CountdownBlock } from "./Countdown.js";
import { RsvpBlock } from "./Rsvp.js";
import { Footer } from "./Footer.js";

const STORAGE_LANG = "h50.lang";
const STORAGE_DARK = "h50.dark";

export function Page() {
  // Server renders defaults; the inline script in document.tsx flips
  // documentElement attrs before paint so dark-mode users don't see a cream
  // flash. After mount we read localStorage and re-render in the user's
  // preference (one re-render for return visitors on DE / dark).
  const [lang, setLangState] = React.useState<Lang>("en");
  const [dark, setDarkState] = React.useState(false);

  React.useEffect(() => {
    if (window.localStorage.getItem(STORAGE_LANG) === "de") setLangState("de");
    if (window.localStorage.getItem(STORAGE_DARK) === "true") setDarkState(true);
  }, []);

  React.useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("data-dark", dark ? "true" : "false");
  }, [lang, dark]);

  const setLang = (l: Lang) => {
    setLangState(l);
    window.localStorage.setItem(STORAGE_LANG, l);
  };
  const setDark = (d: boolean) => {
    setDarkState(d);
    window.localStorage.setItem(STORAGE_DARK, d ? "true" : "false");
  };

  return (
    <>
      <TopBar lang={lang} setLang={setLang} dark={dark} setDark={setDark} />
      <Hero lang={lang} />
      <DetailsStrip lang={lang} />
      <EveningBlock lang={lang} />
      <VenueBlock lang={lang} />
      <CountdownBlock lang={lang} />
      <RsvpBlock lang={lang} />
      <Footer lang={lang} />
    </>
  );
}
